<template>
  <!-- banner   -->
    <div class="banner">
      <div class="banner-txt" v-if="$route.path=='/index' && aboutContent" >
        <div class="banner-cont" :class="moreTxt?'unfold':''" v-html="aboutContent"></div>
        <div class="banner-btn" v-if="!moreTxt" @click="showMore" title="更多">
          <span>更多</span>
          <span class="iconfont icon-arrow-down"></span>
        </div>
        <div class="banner-btn" v-else @click="hideMore" title="收起">
          <span>收起</span>
          <span class="iconfont icon-arrow-up"></span>
        </div>
      </div>
      
    </div>
</template>

<script>
import { mapState,mapActions } from 'vuex'
export default {
  name: 'banner',
  data(){
    return{
      moreTxt:false
    }
  },
  computed:{
    ...mapState(['aboutContent'])
  },
  mounted() {
    if(this.$route.path=='/index' && !this.aboutContent ){
        this.getAbout()
      }
  },
  methods: {
    ...mapActions(["getAbout"]),
    showMore(){
      this.moreTxt = true
    },
    hideMore() {
      this.moreTxt = false
    }
  },
}
</script>